//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CouponTabList from "./components/couponTabList";
import { getCheckCoupon } from "./index";
import { insurancePage } from "@/model/javaApi/detail.js";
import Inform from "@/views/stencil/components/inform.vue";

export default {
	data() {
		return {
			list: [],
			current: {
				commodityCode: "",
			}, // 选中的项目
			institutionName: "",
			inform: false,
			couponCode: null,
		};
	},
	components: {
		CouponTabList,
		Inform,
	},
	mounted() {
		this.check();
		this.STATISTICS_CONFIG.insur_choosetype_page();
	},
	activated() {
		this.check();
		if (this.inform) {
			this.inform = false;
		}
	},
	methods: {
		check() {
			getCheckCoupon().then((res) => {
				/** 检查缓存是否有变化，有变化，就更新，没有变化，就保持当下 */
				if (this.couponCode === res.couponCode) {
					return;
				}
				if (res) {
					this.couponCode = res.couponCode;
					this.list = res.categories;
					this.institutionName = res.institutionName;
				} else {
					router.replace({
						path: "/presentCouponUse",
					});
				}
			});
		},
		next() {
			if (!this.current.commodityCode) return false;
			this.$router.push({
				path: "/presentCouponInfo",
				query: {
					commodityCode: this.current.commodityCode,
					schemeCode: this.current.schemeCode,
					name: this.current.category,
				},
			});
		},
		async getInfo() {
			if (!this.current.commodityCode) return false;
			this.STATISTICS_CONFIG.insur_choosetype_next_click();

			let channelCommodityCode = this.current.commodityCode;
			let data = await insurancePage({ channelCommodityCode });
			this.processTips = data.processTips;
			this.inform = true;
		},
	},
};
